module.exports = __webpack_public_path__ + "static/media/weddings-reception.22e33810.jpg";